<template>
  <v-card class="pa-3 text-center">
    <v-card-title class="justify-center">{{ number }}</v-card-title>
    <v-card-subtitle class="mt-0">{{ title }}</v-card-subtitle>
  </v-card>
</template>

<script>
export default {
  props: ["title", "number"],
  data() {
    return {};
  },
  methods: {},
  mounted() {},
};
</script>

<style scoped>
.chart-container {
  height: 400px;
  position: relative;
}
.text-center {
  text-align: center;
  font-size: 16px;
  color: #777;
}
</style>
